import React from "react";

const EditIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="18"
      height="18"
      viewBox="0 0 18 18"
    >
      <defs></defs>
      <path
        className="a"
        d="M4.5,18.747V22.5H8.249L19.308,11.438,15.558,7.688ZM22.207,8.538a1,1,0,0,0,0-1.41l-2.34-2.34a1,1,0,0,0-1.41,0l-1.83,1.83,3.749,3.749Z"
        transform="translate(-4.5 -4.496)"
      />
    </svg>
  );
};
export default EditIcon;
